
import React from 'react';
import { Phone, Mail } from 'lucide-react';

const ContactInfo: React.FC = () => {
  return (
    <div className="mt-6 p-4 rounded-xl border border-gray-200 bg-white/80 shadow-sm">
      <h3 className="text-lg font-medium mb-3">Potrzebujesz pomocy?</h3>
      <p className="text-gray-600 mb-4">
        Skontaktuj się z naszym konsultantem, aby uzyskać więcej informacji o naszych ofertach.
      </p>
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex items-center gap-2">
          <div className="bg-primary/10 p-2 rounded-full">
            <Phone className="h-5 w-5 text-primary" />
          </div>
          <div>
            <p className="text-sm text-gray-500">Telefon</p>
            <a href="tel:+48123456789" className="font-medium hover:text-primary transition-colors">
              +48 123 456 789
            </a>
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          <div className="bg-primary/10 p-2 rounded-full">
            <Mail className="h-5 w-5 text-primary" />
          </div>
          <div>
            <p className="text-sm text-gray-500">Email</p>
            <a href="mailto:kontakt@chillwise.pl" className="font-medium hover:text-primary transition-colors">
              kontakt@chillwise.pl
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
